import React from "react";
import "./spinner.css";
import PacmanLoader from "react-spinners/PacmanLoader";

const Spinner = () => {
  return (
    <>
      <div className="loaderStyle">
        <PacmanLoader
          size={100}
          color="#f7444e"
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    </>
  );
};

export default Spinner;
